import { render, staticRenderFns } from "./SingleEmployee.vue?vue&type=template&id=b7b5fa4e&"
import script from "./SingleEmployee.vue?vue&type=script&lang=js&"
export * from "./SingleEmployee.vue?vue&type=script&lang=js&"
import style0 from "./SingleEmployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports